import { PlanGate } from '@relay-towing/ui';
import type { PlanFeature } from '@relay-towing/api';
import { featureMessage, upgradePlans } from '@relay-towing/api';
import { usePlan } from '../../hooks/usePlan';
import { links } from '../../lib/links';
import { openExternal } from '../../lib/nativeBridge';

/**
 * What a member sees on reaching for something their plan lacks. One who
 * can change the plan (`subscription.view`) gets the plans that include it
 * and Upgrade, which opens the dashboard's billing; everyone else the reason
 * and "Ask your owner to upgrade". Permissions decide whether a control
 * shows at all; this is for one the plan excludes.
 */
export function FeatureUpsell({
  open,
  onOpenChange,
  feature,
  title,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  feature: PlanFeature;
  title: string;
}) {
  const plan = usePlan();
  const catalogue = plan.catalogue;
  const message =
    catalogue && plan.plan
      ? featureMessage(catalogue, plan.plan.id, feature)
      : 'This is not on your plan.';
  const close = () => onOpenChange(false);

  return (
    <PlanGate
      presentation="sheet"
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      message={message}
      detail={
        plan.canUpgrade ? 'Select an upgrade and we’ll do the rest.' : undefined
      }
      canUpgrade={plan.canUpgrade}
      plans={
        plan.canUpgrade && catalogue && plan.plan
          ? upgradePlans(catalogue, plan.plan.id, { feature })
          : undefined
      }
      primaryLabel={plan.canUpgrade ? 'Upgrade' : undefined}
      onPrimary={
        plan.canUpgrade
          ? () => {
              openExternal(links.billing);
              close();
            }
          : undefined
      }
      dismissLabel={plan.canUpgrade ? 'No thanks' : 'Close'}
      onDismiss={close}
    />
  );
}
